import FormConfig from "../formConfig.js";
import { fun_PostAction } from "@/api/index";
export default {
  data() {
    return {
      // 列表loading状态
      loading: false,
      // 表单对象
      form: {
        id: null, // 主键
        typeCode: null, // 编码
        typeName: null, // 名称
        tradeType: null, // 注册类型
      },
      // 表单错误
      errRules: {
        id: null, // 主键
        typeCode: null, // 编码
        typeName: null, // 名称
        tradeType: null, // 注册类型
      },
      // 表单配置
      formConfigList: FormConfig.configList(),
      controllerFlg: null, // 页面类型
      activeName: null, // 一览切换name
    };
  },
  // 注册组件
  components: {
  },
  // 模板编译完成
  mounted() {
    // 打开loading
    this.loading = true;
    // 获取页面类型
    this.controllerFlg = this.$route.query.type;
    // 获取切换name
    this.activeName = this.$route.query.activeName;
    // 获取切换id
    this.id = this.$route.query.id;
    // 判断
    if(this.activeName === "1"){
      // 更换显示内容
      this.formConfigList = FormConfig.configList();
      // 替换表单对象
      this.form = {
        id: null, // 主键
        typeCode: null, // 编码
        typeName: null, // 名称
        tradeType: null, // 注册类型
      };
      // 替换表单错误信息
      this.errRules = {
        typeCode: null, // 编码
        typeName: null, // 名称
        tradeType: null, // 注册类型
      };
    }else{
      // 更换显示内容
      this.formConfigList = FormConfig.regTradeLevel();
      // 替换表单对象
      this.form = {
        id: null, // 主键
        tradeType: null, // 注册类型
        typeLevelNum: null, // 注册等级编码
        typeLevelName: null, // 注册等级名称
        typeLevelNo: null, // 注册等级编号
      };
      // 替换表单错误信息
      this.errRules = {
        tradeType: null, // 注册类型
        typeLevelNum: null, // 注册等级编码
        typeLevelName: null, // 注册等级名称
        typeLevelNo: null, // 注册等级编号
      };
    }
    // 如果是详情
    if (this.controllerFlg == "details") {
      // 获取详情信息
      this.fun_Details();
      // 遍历表单
      this.formConfigList.map(e => {
        // 遍历
        e.formConfigList.map(form => {
          // 不可编辑
          form.disabled = true;
        });
      });
    }
    // 如果是修改
    else if (this.controllerFlg == "update") {
      // 获取详情信息
      this.fun_Details();
    }
  },
  // 自定义方法
  methods: {
    /**
     * @description 详情
     * @author
     */
    fun_Details() {
      // 请求，获取结果集
      fun_PostAction(`${this.activeName === "1" ? "/regTradeType/detail" : "/regTradeLevel/detail"}`, {
        id: this.id
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 数据回显
          this.form = data;
          // 关闭loading
          this.loading = false;
        }
      });
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },
    /**
     * @description 保存或修改
     * @author
     */
    fun_SaveOrUpdate() {
      // 遍历错误消息
      for (let i in this.errRules) {
        // 设置为空
        this.errRules[i] = null;
      }
      // 表单验证
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 验证通过
        if (valid) {
          // 请求
          fun_PostAction(`${this.activeName === "1" ? "/regTradeType/saveOrUpdate" : "/regTradeLevel/saveOrUpdate"}`, {
            ...this.form, // form表单数据
            controllerFlg: this.controllerFlg // 操作标志
          }).then(res => {
            // 解构res.data
            const { result, data, msg } = res.data;
            // 解析后台返回的结果集，判断是否成功
            if (result) {
              // 操作成功
              this.$message.success(msg);
              // 返回一览
              this.fun_Back();
            } else {
              // 如果页面验证失败
              if (data != null && data != "") {
                // 返回错误消息
                this.errRules = data;
                // 请求失败，弹出失败msg的消息提示
                this.$message.error("您输入的数据存在错误！");
              } else {
                // 请求失败，弹出失败msg的消息提示
                this.$message.error(msg);
              }
            }
            // 关闭loading
            this.loading = false;
          });
        } else {
          // 关闭loading
          this.loading = false;
          // 提示
          this.$alert("页面存在错误信息，请检查后重试！", "warning");
          return false;
        }
      });
    },
    /**
     * 返回的方法
     */
    fun_Back() {
      // 跳转一览页面
      this.$router.push({path: "/regTradeType", query: {activeName:this.activeName}});
    },
  }
};
